import React, { useState } from 'react';
import { useEffect } from 'react';

import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import MoveToProjectComponent from '../MoveToProjectComponent'
import { baseURL } from "../utils";
import {authFetch,handleResponse} from '../utils'
import moment from 'moment';
//import ProgressBar from 'react-bootstrap/ProgressBar'
import { Line } from 'react-chartjs-2';
// eslint-disable-next-line no-unused-vars
import { Chart as ChartJS } from 'chart.js/auto'

// eslint-disable-next-line no-unused-vars
import { Chart }            from 'react-chartjs-2'
function Result(props) {

  function getFormattedDate(time){
    return moment(time,"YYYY-MM-DD").format("DD-MMM")
  }
 
  console.log("Size"+props.data.length)
  const chartoptions={'type': 'line'}

  var chartDate =props.data.length!==0 
  ? {
    labels:props.data.map((record)=>(getFormattedDate(record.startDateQueryParam))).reverse(),
    datasets: [
      {
        label: 'Completed Tasks',
        backgroundColor: 'rgba(0, 0, 120)',
        data:props.data.map((record)=>(record.completedTaskCounter.count)).reverse()
        
      }, {
        label: 'Added Tasks',
        data:props.data.map((record)=>(record.addedTaskCounter.count)).reverse()
      },  {
        label: 'Schedule Stickiness',
        type: 'bar',
        backgroundColor: 
        props.data.map((record)=>record.previousResult &&  record.previousResult.scheduleStickinessCounter && record.previousResult.scheduleStickinessCounter.percent>record.scheduleStickinessCounter.percent?'rgba(255, 99, 132,0.2)':'rgba(75, 192, 192, 0.2)').reverse()
          ,
          borderColor: props.data.map((record)=>record.previousResult &&  record.previousResult.scheduleStickinessCounter && record.previousResult.scheduleStickinessCounter.percent>record.scheduleStickinessCounter.percent?'rgb(255, 99, 132)':'rgb(75, 192, 192)').reverse()
          ,
            borderWidth: 1,
        data:props.data.map((record)=>(record.scheduleStickinessCounter.percent)).reverse()
      }
    ]
  }:null;
//console.log(chartDate)
  /*function getFormattedDate(time){
    return moment(time,"YYYY-MM-DD").format("DD-MMM")
  }*/

  
  return (
    <>
    
    {
   
    props.data.length!==0 && <>
    
    <Line options={chartoptions} data={chartDate}/>

   {/**<Table striped bordered hover>
      <thead>
        <tr>
          <th>#</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Completed Task Counter</th>
          <th>Added Task Counter</th>
          <th>Schedule Stickiness</th>
          
        </tr>
      </thead>
      <tbody>
        {
          
          props.data.map((record, index)=>(
            record.type==="organizer" &&  
            <tr key={index}>
          <td>{index+1}</td>
          <td>{getFormattedDate(record.startDateQueryParam)}</td>
          <td>{getFormattedDate(record.endDateQueryParam)}</td>
          <td class={record.previousResult  && record.previousResult.completedTaskCounter.count>record.completedTaskCounter.count?"text-danger":""} >{record.completedTaskCounter.count}</td>
          <td class={record.previousResult  && record.previousResult.addedTaskCounter.count>record.addedTaskCounter.count?"text-danger":""}>{record.addedTaskCounter.count}</td>
          { record.scheduleStickinessCounter && record.scheduleStickinessCounter.percent && <td ><ProgressBar variant={ record.previousResult &&  record.previousResult.scheduleStickinessCounter && record.previousResult.scheduleStickinessCounter.percent>record.scheduleStickinessCounter.percent?"danger":"success"} label={`${Math.round(record.scheduleStickinessCounter.percent)}%`} now={Math.round(record.scheduleStickinessCounter.percent)}></ProgressBar></td>}
         
        </tr>
          ))
         
      }
      </tbody>
    </Table>
}*/}
    <NonRecurringTaskCompletion data={props.data}></NonRecurringTaskCompletion>
    <RecurringTaskCompletion data={props.data}></RecurringTaskCompletion>
    </>
}
{
  props.data.length===0 && <><Form.Control plaintext readOnly defaultValue="Loading Report..." /><Spinner animation="border" role="status">
  <span className="visually-hidden">Loading...</span>
</Spinner> </>
}
    </>
  );

}

function NonRecurringTaskCompletion(props){
  const lastItemList = props.data && props.data.length>0 && props.data[0].type==="organizer" && props.data[0].completedTaskCounter 
  && props.data[0].completedTaskCounter.nonRecurring  ? props.data[0].completedTaskCounter: null
  
  return(
    <>
    {lastItemList && <Form.Label><b>Average Lead Time in days : {Math.round(lastItemList.averageLeadTimeInDays)}</b></Form.Label> }
    {lastItemList && 
     <Table striped bordered hover>
     <thead>
       <tr>
         <th>#</th>
         <th>Name</th>
         <th>Lead Time In Days</th>
         </tr>
         </thead>
         <tbody>
         {
         
         lastItemList.nonRecurring.map((item, index)=>(
          <tr key={index}>
         <td>{index+1}</td>
         <td>{item.name}</td>
         <td>{item.leadTimeInDays}</td>
         </tr>
         ))
        
     }
         </tbody>
         </Table>
    
    }
    
    </>
  )
}

function RecurringTaskCompletion(props){

  function getFormattedDate(time){
    return moment(time,"YYYY-MM-DD").format("DD-MMM")
  }
  var recurringTasks=[]
  for(var i=0;i<props.data.length;i++){
    if(props.data[i].type==="organizer" && props.data[i].completedTaskCounter.recurring){
      for(var j=0;j<props.data[i].completedTaskCounter.recurring.length;j++){
        var name = props.data[i].completedTaskCounter.recurring[j].name
        if(recurringTasks.indexOf(name)<0)
          recurringTasks.push(name)
      }
    }
  }

  var changeRecurringTask = (event)=>{
    setType(event.target.name)
  }
  const [type, setType] = useState("Select from List");
  
  return(
    <>
   <h3> Recurring Tasks</h3>


   
    <Dropdown>
    <Dropdown.Toggle variant="success" id="dropdown-basic">
      {type}
    </Dropdown.Toggle>
    <Dropdown.Menu>
    {recurringTasks.map((recurringRecord, index)=>(<Dropdown.Item name={recurringRecord} onClick={changeRecurringTask}>{recurringRecord}</Dropdown.Item>))}
      
    </Dropdown.Menu>
    </Dropdown>
    <Table striped bordered hover>
      <thead>
        <tr>
           <th>#</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>{type}</th>
          </tr>
          </thead>
          <tbody>
          {
          
          props.data.map((record, index)=>(
            record.type==="organizer" &&  record.completedTaskCounter && record.completedTaskCounter.recurring && 
            <tr key={index}>
          <td>{index+1}</td>
          <td>{getFormattedDate(record.startDateQueryParam)}</td>
          <td>{getFormattedDate(record.endDateQueryParam)}</td>
          <td>{record.completedTaskCounter.recurring.filter(recurringTask=>recurringTask.name===type).map(recurringTask=>recurringTask.count)}</td>
        </tr>
          ))
         
      }
          </tbody>
          </Table>
          <ThingsToFocus>

          </ThingsToFocus>
    </>
  )
}

function ThingsToFocus(props){
  const [currentThingsToFocus, setCurrentThingsToFocus] = useState([]);
  const [projects, setProjects] = useState([]);

 
  const onSaveClick=function(){
    authFetch(baseURL+'/v1/user/itemsToFocus',{	method: 'PATCH',	body: JSON.stringify({
			
      itemsToFocus: currentThingsToFocus,
    
    
  })})
    .then(res => handleResponse(res))
    .then((result) => {
      setCurrentThingsToFocus(result)
    },        (error) => {
      
      console.log(error)
    });
  }
  const onProjectChange=function(key,event){
    const matchingProject = projects.filter(project=>project.name===event)
    if(matchingProject!==undefined && matchingProject.length===1){
    currentThingsToFocus[key].project=matchingProject[0]
    setCurrentThingsToFocus(currentThingsToFocus)
    }
  }

  const onDelete=function(key){
    // currentThingsToFocus.splice(key,1)
    const newarray=[]
    for (let i = 0; i < currentThingsToFocus.length; i++) {
      if (i!==key) {
        newarray.push(currentThingsToFocus[i]);
      }
    }
    setCurrentThingsToFocus(newarray)
  
}
  
  const onAddClick=function(){
    const defaultThingToAdd={"project":{},"startDate": "12-12-2021"};
    setCurrentThingsToFocus([...currentThingsToFocus,defaultThingToAdd]);
  }
  useEffect(() => {
    authFetch(baseURL+'/v1/user/itemsToFocus')
    .then(res => handleResponse(res))
    .then((result) => {
      setCurrentThingsToFocus(result)
    },        (error) => {
      
      console.log(error)
    });
  },[])
  useEffect(() => {
     
    setCurrentThingsToFocus([])
    authFetch(baseURL+'/v1/task/project')
    .then(res => handleResponse(res))
    .then((result) => {
     setProjects(result.projects)
    },        (error) => {
      
      console.log(error)
    });
  
  },[])
  return(
    <>
    <h3>Items to Focus</h3>
    {currentThingsToFocus.map((currentThingToFocus,index)=>(<ThingToFocus onDelete={onDelete} onProjectChange={onProjectChange} i={index} key={currentThingToFocus.project.name} currentThingToFocus={currentThingToFocus}  projects={projects}></ThingToFocus>))}
    <Button onClick={onAddClick} variant="primary">Add</Button>{' '}
    <Button onClick={onSaveClick} variant="secondary">Save</Button>{' '}
    </>
  )

}

function ThingToFocus(props){

  const onProjectChange=function(event){
    props.onProjectChange(props.i,event)
  }

  const onDelete=function(){
    props.onDelete(props.i)
  }


  return(
    <>
    <div>Select item from below list</div>
  <MoveToProjectComponent onProjectChange={onProjectChange}  currentProject={props.currentThingToFocus.project} projects={props.projects}>

  </MoveToProjectComponent>
  <Button onClick={onDelete} variant="danger">Delete</Button>{' '}
  </>
  )
}

export default Result;